const PilotageTable = ({
  columns,
  rows,
  loading = false,
  emptyMessage = "Aucune donnée disponible.",
  rowKey = "id",
  renderActions = null,
}) => {
  return (
    <div className="overflow-hidden rounded-3xl border border-white/10 glass">
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-white/10">
          <thead className="bg-white/5">
            <tr>
              {columns.map((column) => (
                <th
                  key={column.key}
                  className={`px-4 py-3 text-left text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-400 ${
                    column.className || ""
                  }`}
                >
                  {column.label}
                </th>
              ))}
              {renderActions ? (
                <th className="px-4 py-3 text-right text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-400">
                  Actions
                </th>
              ) : null}
            </tr>
          </thead>
          <tbody className="divide-y divide-white/5">
            {loading ? (
              <tr>
                <td
                  className="px-4 py-10 text-center text-sm text-slate-400"
                  colSpan={columns.length + (renderActions ? 1 : 0)}
                >
                  Chargement...
                </td>
              </tr>
            ) : null}

            {!loading && rows.length === 0 ? (
              <tr>
                <td
                  className="px-4 py-10 text-center text-sm text-slate-400"
                  colSpan={columns.length + (renderActions ? 1 : 0)}
                >
                  {emptyMessage}
                </td>
              </tr>
            ) : null}

            {!loading
              ? rows.map((row) => (
                  <tr key={row[rowKey] ?? row.id} className="hover:bg-white/[0.03]">
                    {columns.map((column) => (
                      <td
                        key={column.key}
                        className={`px-4 py-3 align-top text-sm text-slate-100 ${
                          column.cellClassName || ""
                        }`}
                      >
                        {column.render ? column.render(row) : row[column.key] ?? "—"}
                      </td>
                    ))}
                    {renderActions ? (
                      <td className="px-4 py-3 align-top text-right">
                        {renderActions(row)}
                      </td>
                    ) : null}
                  </tr>
                ))
              : null}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PilotageTable;
